import SigninPackMixin from "@/mixins/signinPack.mixin.js";

export default {
    mixins: [SigninPackMixin],
    data () {
        return {
            passwordMatchAlert: false,
            isValidPass: false,
            clazzPasswordStatus: "",
            labelPasswordStatus: "",
            showStatusBar: false
        }
    },
    methods: {
        getPositivePoints (password) {
            const numberOfCharacters = password.length;
            const uppercaseLetters = (password.match(/[A-Z]/g) || []).length;
            const lowercaseLetters = (password.match(/[a-z]/g) || []).length;
            const numberOnPassword = (password.match(/[0-9]/g, "") || []).length;
            const symbols =
                numberOfCharacters -
                uppercaseLetters -
                lowercaseLetters -
                numberOnPassword;

            let middleSymbolsNumbers = symbols + numberOnPassword;
            if (numberOfCharacters > 2 && (symbols > 0 || numberOnPassword > 0)) {
                if (password[0].match(/[a-zA-Z]/g) == null) {
                    middleSymbolsNumbers -= 1;
                }

                if (password[numberOfCharacters - 1].match(/[a-zA-Z]/g) == null) {
                    middleSymbolsNumbers -= 1;
                }
                if (middleSymbolsNumbers < 0) {
                    middleSymbolsNumbers = 0;
                }
            }

            let requirements = 0;
            if (
                numberOfCharacters > 11 &&
                uppercaseLetters > 0 &&
                lowercaseLetters > 0 &&
                numberOnPassword > 0 &&
                symbols > 0
            ) {
                requirements = 10;
            }

            return (
                numberOfCharacters * 4 +
                (numberOfCharacters - uppercaseLetters) * 2 +
                (numberOfCharacters - lowercaseLetters) * 2 +
                numberOnPassword * 4 +
                symbols * 6 +
                middleSymbolsNumbers * 2 +
                requirements
            );
        },
        onPasswordChangeRegister (password) {
            this.registerPassword = password;
            let positivePoints = this.getPositivePoints(password);
            if (/^[a-zA-Z]+$/.test(password)) {
                positivePoints = positivePoints - password.length;
            }
            if (/^\d+$/.test(password)) {
                positivePoints = positivePoints - password.length;
            }
            positivePoints += this.getRepeatCharacter(password);
            const groups = password.match(/[A-Z]+|[a-z]+|[0-9]+/g);
            if (groups) {
                const groupsFilter = groups.filter(function (element) {
                return element.length >= 2;
                });

                let consecutiveCharacter = 0;
                for (const group of groupsFilter) {
                consecutiveCharacter += (group.length - 1) * 2;
                }

                positivePoints -= consecutiveCharacter;
            }

            positivePoints -= this.sequential(password);
            positivePoints -= this.sequentialSymbols(password);
            if (positivePoints <= 0 && password.length > 0) {
                positivePoints = 1;
            }
            if(this.isValidPassword(password)){
                positivePoints +=10;
                this.isValidPass = true
            } else {
                positivePoints = 10
            }
            if (positivePoints === 0) {
                this.clazzPasswordStatus = "";
                this.labelPasswordStatus = "";
                this.showStatusBar = false;
            } else if (positivePoints < 40) {
                this.clazzPasswordStatus = "weak";
                this.labelPasswordStatus = 'register.passStatusWeak';
                this.showStatusBar = true;
            } else if (positivePoints < 60) {
                this.clazzPasswordStatus = "regular";
                this.labelPasswordStatus = 'register.passStatusRegular';
                this.showStatusBar = true;
            } else if (positivePoints < 80) {
                this.clazzPasswordStatus = "good";
                this.labelPasswordStatus = 'register.passStatusGood';
                this.showStatusBar = true;
            } else {
                this.clazzPasswordStatus = "excellent";
                this.labelPasswordStatus = 'register.passStatusExc';
                this.showStatusBar = true;
            }
        },
        sequential(password){
            const passwordLowercase = password.toLowerCase();
            let groups = passwordLowercase.match(/[A-Z]+|[a-z]+|[0-9]+/g);
            let score = 0;
            if (groups) {
                groups = groups.filter(function (element) {
                    return element.length >= 3;
                });
                for (const group of groups) {
                    let splitGroup = [];
                    for (let i = 0; i < group.split("").length - 2; i++) {
                        splitGroup.push(group.substring(i, i + 3));
                    }
                    splitGroup = [...new Set(splitGroup)];
                    score = this._sequentialLoop1(splitGroup, score);
                    score = this._sequentialLoop2(splitGroup, score);
                }
            }
            return score * 3;
        },
        sequentialSymbols(password) {
            const groups = password.match(/[^a-zA-z0-9]+/g);
            let score = 0;
            if (groups) {
                let triGroups = [];
                for (const group of groups) {
                    triGroups = triGroups.concat(group.match(/.{1,3}/g));
                }
                triGroups = [...new Set(triGroups)];
                triGroups = triGroups.filter(function (element) {
                    return element.length === 3;
                });
                score = triGroups.length;
            }
            return score * 3;
        },
        hasSecuentialCharacteresString(value) {
            const score = this.sequential(value);
            return score > 0;
        },
        hasRepetedCharacteresString(value) {
            return /(.)\1\1/.test(value);
        },
        hasANumberString(value){
            return /\d/.test(value);
        },
        hasCapitalLetterString(value){
            return /[A-Z]/.test(value);
        },
        hasSpecialCharacteresString(value){
            return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value);
        },
        hasAString(value, stringToFind){
            return value.toLowerCase().includes(stringToFind.toLowerCase());
        },
        isValidPassword(value){
            return !this.hasSecuentialCharacteresString(value)
            && !this.hasRepetedCharacteresString(value)
            && value.length >= 12 && this.hasANumberString(value)
            && this.hasCapitalLetterString(value)
            && this.hasSpecialCharacteresString(value)
            && !this.hasAString(value, "Pagando")
            && !this.hasAString(value, "Check")
            && !this.hasAString(value, "Wallet");
        },
        _sequentialLoop1(splitGroup, score) {
            for (const splitGroupElement of splitGroup) {
                let point = 0;
                for (
                    let i = 0;
                    i < splitGroupElement.split("").length - 1;
                    i++
                ) {
                    if (splitGroupElement[i] < splitGroupElement[i + 1]) {
                        if (
                            this._nextChar(splitGroupElement[i]) ===
                            splitGroupElement[i + 1]
                        ) {
                            point += 0.5;
                        } else {
                            break;
                        }
                    } else {
                        break;
                    }
                }
                if (point === 1) {
                    score += 1;
                }
            }
            return score;
        },
        _sequentialLoop2(splitGroup, score) {
            for (const splitGroupElement of splitGroup) {
                let point = 0;
                for (
                    let i = 0;
                    i < splitGroupElement.split("").length - 1;
                    i++
                ) {
                    if (splitGroupElement[i] > splitGroupElement[i + 1]) {
                        if (
                            this._prevChar(splitGroupElement[i]) === splitGroupElement[i + 1]
                        ) {
                            point += 0.5;
                        } else {
                            break;
                        }
                    } else {
                        break;
                    }
                }
                if (point === 1) {
                    score += 1;
                }
            }
            return score;
        },
        _nextChar(c) {
            return String.fromCharCode(c.charCodeAt(0) + 1);
        },
        _prevChar(c) {
            return String.fromCharCode(c.charCodeAt(0) - 1);
        }
    }
};
